import script from "./ml-collapse-panel.vue?vue&type=script&setup=true&lang=js"
export * from "./ml-collapse-panel.vue?vue&type=script&setup=true&lang=js"

import "./ml-collapse-panel.vue?vue&type=style&index=0&id=2d216906&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\项目\\公司\\cloudeffective-official-website-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d216906"]])

export default __exports__